import { Box, Typography, Chip, Stack } from "@mui/material";
import { useReveal } from "../Motion";

// The page header rises in as the page arrives: chips, title, subtitle, then
// description, 50ms apart. These play on mount rather than on scroll - they
// are the first thing on the page.
const PageHero = ({
  title,
  subtitle,
  description,
  chips = [],
  align = "center",
  sx = {},
}) => {
  const chipsReveal = useReveal({ trigger: "mount", index: 0 });
  const titleReveal = useReveal({ trigger: "mount", index: 1 });
  const subtitleReveal = useReveal({ trigger: "mount", index: 2 });
  const descriptionReveal = useReveal({ trigger: "mount", index: 3 });

  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        px: { xs: 2, md: 3 },
        display: "flex",
        justifyContent: "center",
        ...sx,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "800px",
          textAlign: align,
        }}
      >
        {chips.length > 0 && (
          <Stack
            ref={chipsReveal.ref}
            {...chipsReveal.props}
            direction="row"
            spacing={1}
            sx={{
              mb: 2,
              justifyContent: align === "center" ? "center" : "flex-start",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            {chips.map((chip, index) => (
              <Chip
                key={index}
                label={chip.label}
                size="small"
                sx={{
                  backgroundColor: chip.color || "rgba(255, 255, 255, 0.15)",
                  color: "#fff",
                  fontFamily: "Roboto, sans-serif",
                  fontSize: "11px",
                  fontWeight: 500,
                  height: "24px",
                  "& .MuiChip-label": {
                    px: 1.5,
                  },
                }}
              />
            ))}
          </Stack>
        )}

        <Typography
          ref={titleReveal.ref}
          {...titleReveal.props}
          variant="sectionTitle"
          component="h1"
          sx={{
            color: "#fff",
            mb: subtitle ? 1 : 2,
            fontSize: { xs: "32px", md: "40px" },
            letterSpacing: { xs: "4px", md: "6px" },
          }}
        >
          {title}
        </Typography>

        {subtitle && (
          <Typography
            ref={subtitleReveal.ref}
            {...subtitleReveal.props}
            sx={{
              fontFamily: "Roboto, sans-serif",
              color: "rgba(255, 255, 255, 0.9)",
              fontSize: { xs: "16px", md: "18px" },
              fontWeight: 400,
              mb: 2,
            }}
          >
            {subtitle}
          </Typography>
        )}

        {description && (
          <Typography
            ref={descriptionReveal.ref}
            {...descriptionReveal.props}
            sx={{
              fontFamily: "Kalam, cursive",
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: { xs: "14px", md: "16px" },
              lineHeight: 1.7,
              maxWidth: "600px",
              mx: align === "center" ? "auto" : 0,
            }}
          >
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default PageHero;
